import React from 'react'

export const FontAwesomeIcon = ({ icon }) => (
    <i className={`fa fa-${icon}`}></i>
);